export default __webpack_public_path__ + "static/media/benefit_15@3x.2e1c28ab.png";